export const calcPeaksInRanges = (
  data: { d: string; v: number }[],
  ranges: { start: string; end: string }[]
) => {
  return ranges.map(wave => {
    const waveData = data.filter(
      m =>
        new Date(m.d) >= new Date(wave.start) &&
        new Date(m.d) <= new Date(wave.end)
    )
    const wavemax = Math.max(...waveData.map(m => m.v))
    const peak = waveData.find(f => f.v === wavemax)
    return {
      d: peak ? peak.d : '',
      v: wavemax,
      t: wavemax.toString()
    }
  })
}
